const Instructions = () => {
  return (
    <div className="Main__instructions">
      <ul>
        <li>Use the writing area to work on your daily writing.</li>
        <li>
          Don't forget to keep the flow going -- if you haven't written anything
          in 15 seconds, we'll let you know so you can get back in the groove!
        </li>
        <li>
          You can hover over the clock icon to see how much time you have left.
          When you have two minutes left, it will let you know the remaining
          time directly
        </li>
        <li>
          If you like, you can add a prompt to our database of writing prompts
          so others can (one day) work off your suggestion!
        </li>
      </ul>
    </div>
  );
};

export default Instructions;
